<template>
  <v-container>
    <v-toolbar dense dark color="secondary">
      <v-toolbar-title>{{TranslateText('Inspection - Allocate')}}</v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-form>
        <v-container>
          <v-layout row wrap>
            <v-flex xs10 md6>
              <v-select label="Customer" :items="CustomerList" item-text="Name" item-value="ID"
                v-model="SelectedCustomerID"></v-select>
              <v-select label="Customer Inspection" :items="CustomerInspectionList" item-text="Name" item-value="ID"
                :disabled="SelectedCustomerID == null" v-model="form.CustomerInspectionID"></v-select>
              <v-select label="System Users" :items="SystemUserList" item-text="FirstName" item-value="ID"
                v-model="form.SystemUserID"></v-select>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="AllocateInspection">Save</v-btn>
            <v-btn color="error" @click="$router.push('/inspections')">Cancel</v-btn>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        CustomerList: [],
        CustomerInspectionList: [],
        SystemUserList: [],
        SelectedCustomerID: null,
        form: {
          SystemUserID: null,
          CustomerInspectionID: null,
          DateTime: null
        }
      };
    },
    watch: {
      SelectedCustomerID() {
        this.fetchCustomerInspections();
      }
    },
    mounted() {
      this.fetchCustomers();
      this.fetchSystemUsers();
    },
    methods: {
      fetchCustomers() {
        let self = this;

        self.get(`Customer`).then(r => {
          self.CustomerList = r.data;
        });
      },
      fetchCustomerInspections() {
        let self = this;
        let customerID = self.SelectedCustomerID;

        self
          .get(`CustomerInspections/GetByCustomer?customerID=${customerID}`)
          .then(r => {
            r.data.forEach(element => {
              self.CustomerInspectionList.push(element.CustomerInspection);
            });
          });
      },
      fetchSystemUsers() {
        let self = this;

        self.get(`SystemUser`).then(r => {
          console.log(r.data);
          self.SystemUserList = r.data;
        });
      },
      AllocateInspection() {
        let self = this;
        let request = this.form;

        self.post(`SupervisorAllocatedInspection`, request).then(r => {
          if (r.data != null) {
            self.$router.push('/inspections')
          }
        });
      }
    }
  };
</script>

<style>
</style>